var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"px-4 py-2 mb-4",attrs:{"flat":""}},[_c('div',{staticClass:"s2 basic600--text"},[_vm._v(_vm._s(_vm.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }